'use client';

import {Icon} from '@udemy-v2/icons';

import styles from './quick-answer-card.module.scss';

export interface QuickAnswer {
    /** The question, shown as the card's title. */
    question: string;
    /** The answer, shown below the question. */
    answer: string;
}

/**
 * One of the four "quick answer" cards above the FAQ list — Figma nodes 5260:158110 /
 * 5260:158124 / 5260:158138 / 5260:158152 (desktop) and 5260:161879 / 5260:161893 /
 * 5260:161907 / 5260:161921 (mobile), file `mitwWlKOuf1pyo4gUCLEBY`.
 *
 * A bordered white surface with a small tinted disc holding the question-and-answer
 * glyph, above the question and its answer. Presentational and props-only;
 * {@link QuestionsAndAnswers} owns the copy.
 *
 * Renders an `<li>`, so it must sit inside the section's list.
 */
export function QuickAnswerCard({question, answer}: QuickAnswer) {
    return (
        <li className={styles['card']}>
            {/* Decorative: the same glyph repeats on every card, and the question below
                carries the meaning. */}
            <span className={styles['badge']}>
                <Icon glyph="question-answer-outline" label={false} size="xsmall" />
            </span>
            <div className={styles['copy']}>
                <h3 className={styles['question']}>{question}</h3>
                <p className={styles['answer']}>{answer}</p>
            </div>
        </li>
    );
}
